import { ResendEmailVerificationState } from './resendEmailVerification.types'

const initialState: ResendEmailVerificationState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
